import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  constructor() {}

  getClientErrorMessage(_error: HttpErrorResponse): string {
    //return 'Something Went Wrong';
    // return navigator.onLine ?
    console.log('Error Object:', _error);
    return        _error?.error?.message ? _error.error.message : 'Something Went Wrong';
  }

  getServerErrorMessage(error: HttpErrorResponse): string {
    return error.message;
  }
}
